export const getErrorMessage = (response: any) => {
  response = response.reason || response;

  if (response.status === 400) {
    return response.data.Message;
  }

  return 'недостаточно данных';
};
